import { useState, useEffect } from 'react';
import { Church } from './useChurches';

const RECENT_CHURCHES_KEY = 'recentChurches';
const MAX_RECENT_CHURCHES = 5;

export function useRecentChurches() {
  const [recentChurches, setRecentChurches] = useState<string[]>([]);

  useEffect(() => {
    // Load recent churches from localStorage
    const stored = localStorage.getItem(RECENT_CHURCHES_KEY);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed)) {
          setRecentChurches(parsed);
        }
      } catch (error) {
        console.warn('Failed to parse recent churches from localStorage:', error);
      }
    }
  }, []);

  const addRecentChurch = (churchId: string) => {
    setRecentChurches(prev => {
      // Remove if already exists and add to front
      const filtered = prev.filter(id => id !== churchId);
      const updated = [churchId, ...filtered].slice(0, MAX_RECENT_CHURCHES);
      
      // Save to localStorage
      localStorage.setItem(RECENT_CHURCHES_KEY, JSON.stringify(updated));
      
      return updated;
    });
  };

  const getRecentChurches = (allChurches: Church[]): Church[] => {
    return recentChurches
      .map(id => allChurches.find(church => church.id === id))
      .filter((church): church is Church => church !== undefined);
  };

  return {
    recentChurches,
    addRecentChurch,
    getRecentChurches,
  };
}
